import axios from "@/api/axiosInstance";
import { CreateCourseRequest, CreateCourseResponse } from "./types";

export const createCourse = async (
  requestData: CreateCourseRequest,
): Promise<CreateCourseResponse> => {
  const response = await axios.post<CreateCourseResponse>(
    "/api/private/learning-center/courses",
    requestData,
  );
  return response.data;
};
